import { readJson, type ProductPreview } from "../types"
const BASE_URL = "/api/v1"

export class PreviewsBusyError extends Error {}

export async function fetchProductPreview(url: string) {
  const params = new URLSearchParams({ url })
  const response = await fetch(`${BASE_URL}/product_preview?${params}`, {
    credentials: "include",
  })
  if (response.status === 503) throw new PreviewsBusyError("Previews are busy")
  if (!response.ok) return null
  const { data } = await readJson<ProductPreview>(response)
  return data
}
